function customProduct(){
    $('.product').each(function() {
        var product = $(this);
        var shouldExecuteFunction = true;
        for (var i = 0; i < classToHide.length; i++) {
            if (product.find(classToHide[i]).length > 0) {
                shouldExecuteFunction = false;
                break;
            }
        }
        if (shouldExecuteFunction) {
            $(this).find('.price-standard').hide()
            $(this).find('.flag-discount').hide()
        }
    });
}
    

$(document).ready(function(){
    customProduct();
});
    
document.addEventListener('ShoptetDOMPageContentLoaded', function() {
    customProduct();
});
document.addEventListener('ShoptetPageSortingChanged', function() {
    customProduct();
});
document.addEventListener('ShoptetDOMPageMoreProductsLoaded', function() {
    customProduct();
});